export const ShadowShader = {
  uniforms: {
    tDiffuse: { value: null },
    shadowAmount: { value: 0.0 },
    shadowThreshold: { value: 0.5 },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform float shadowAmount;
    uniform float shadowThreshold;
    varying vec2 vUv;

    void main() {
      vec4 color = texture2D(tDiffuse, vUv);

      // Calculate luminance
      float luminance = dot(color.rgb, vec3(0.299, 0.587, 0.114));

      // Calculate shadow factor
      float shadowFactor = smoothstep(0.0, shadowThreshold, luminance);

      // Apply shadow adjustment
      vec3 shadowAdjusted = mix(
        color.rgb * (1.0 + shadowAmount), // Brighten shadows
        color.rgb,                        // Keep highlights unchanged
        shadowFactor
      );

      gl_FragColor = vec4(shadowAdjusted, color.a);
    }
  `,
};
